import {createApp, ref} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import useVuelidate from '@vuelidate/core';
import {helpers, required} from '@vuelidate/validators';
import {postcode} from '../modules/regitValidators';


const app = createApp({
    setup(props) {
        const state = {
            postcode: ref(''),
        };

        const rules = {
            postcode: {
                required: helpers.withMessage('Please enter your postcode', required),
                postcode: helpers.withMessage('Value is not a valid postcode', postcode),
            },
        };

        const v = useVuelidate(rules, state);
        async function submitChecks(e: Event) {
            e.preventDefault();
            e.stopPropagation();

            const validationPassed = await v.value.$validate();
            if (validationPassed) {
                (document.getElementById('landing-form__form--postcode') as HTMLFormElement).submit();
            }
        }

        return {
            postcode: state.postcode,
            v$: v,
            submitChecks,
        };
    },
});

connectVue(app);
configureGlobalComponents(app);
app.mount('#app');
